import React from 'react';
import { Flashbar, FlashbarProps } from '@amzn/awsui-components-react';
import { FlashContextInterface, withFlashContext } from './context';

function FlashMessages(props: FlashContextInterface) {
    const flashes = props.flash.flashes;
    const items: FlashbarProps.MessageDefinition[] = flashes.map((flash) => {
        const id = flash.id;
        const item: FlashbarProps.MessageDefinition = {
            type: flash.type,
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: (event: any) => props.flash.remove(id),
            content: flash.content,
        };
        return item;
    });
    return <Flashbar items={items} />;
}

export default withFlashContext(FlashMessages);
